<template>
    <div class="complex-items" :class="[itemName]">
        <template v-for="(ui, index) in childrenUI">
            <template v-if="ui.isShowFn ? ui.isShowFn(form) : true" >
                <div v-if="ui.type === 'COMPLEX'" :key="ui.name">
                    <span v-show="(isExpand && index > 0 ) || index == 0 ">
                        <label v-if="ui.label" class="box-label"> {{ ui.label }}</label>
                        <div class="COMPLEX-box">
                            <component :ref="ui.name" :is="ui.component.component" :props="ui.component.props" :form="form"></component>
                        </div>
                    </span>
                </div>
                <el-form-item
                    v-else
                    :class="[ui.component.props.className]"
                    :key="ui.name"
                    :label="getLabel(ui)"
                    :prop="ui.name"
                    :rules="ui.rules">
                    <component
                        :ref="ui.name"
                        :ui="ui"
                        :is="ui.component.component"
                        :props="ui.component.props"
                        :value="form[ui.name]"
                        @change="(v) => form[ui.name] = v"
                        ></component>
                </el-form-item>
                <div v-if="itemName == 'description' && index === 0 && childrenUI.length > 1" :key="ui.name+'_btn'" style="text-align: center;" >
                    <el-button type="link" @click="switchExpand"> <i :class="isExpand ? 'el-icon-shousuoshangjiantou' : 'el-icon-shousuoxiajiantou'"></i></el-button>
                </div>
            </template>
            
        </template>
    </div>
</template>

<script>
// 普通的复合型控件
export default {
    props: ['props', 'form'],
    computed: {
        childrenUI() {
            return this.props?.dataSource?.children || []
        },
        itemName() {
            return this.props?.name || ''
        }
    },
    data() {
        return {
            isExpand: this.props?.name === 'description' ? false : true
        }
    },
    methods: {
        switchExpand() {    
            this.isExpand = !this.isExpand;
        },
        getLabel(ui) {
            if(ui.name ==='sell_point_0') {
                return ''
            } else {
                return ui.label
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.complex-items {
    .box-label {
        font-size: 12px;
        color: #606266;
        margin-left: 10px;
    }
    & ::v-deep .COMPLEX-box {
        padding: 5px;
        margin: 5px;
        border: 1px solid #ccc;
       
        .el-form-item {
            margin-bottom: 10px !important;
            display: flex;
            flex-direction: column;
            align-items: center;
            .el-form-item__content {
                margin: 0 !important;
            }
        }
    }
    
}


</style>
